import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AuthPrompt.css';

function AuthPrompt() {
  const { showAuthPrompt, setShowAuthPrompt } = useAuth();

  if (!showAuthPrompt) return null;

  return (
    <AnimatePresence>
      <motion.div 
        className="auth-prompt-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div 
          className="auth-prompt"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
        >
          <button 
            className="close-button"
            onClick={() => setShowAuthPrompt(false)}
          >
            ×
          </button>
          <h2>Join JobsOpportunity</h2>
          <p>Sign in or create an account to apply for jobs and save your preferences.</p>
          <div className="auth-buttons">
            <Link to="/login" className="login-button">
              Sign In
            </Link>
            <Link to="/register" className="register-button">
              Create Account
            </Link>
          </div>
          <button 
            className="continue-exploring"
            onClick={() => setShowAuthPrompt(false)}
          >
            Continue Exploring
          </button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}

export default AuthPrompt; 